export default __webpack_public_path__ + "static/media/Directors' Certificate to Ms Divinia A Segui ( Lipa Branch ).9b0242d6.pdf";